import Layers from "slotworks/graphics/layers/layers";
import { Text, extras, Point, Container } from "pixi.js";
import translations from "slotworks/i18n/translations";
import { Easing, Tween, Interpolation } from "slotworks/utils/tween";
import Components from "slotworks/components/components";
import { debug } from "util";
import { POINT_CONVERSION_COMPRESSED } from "constants";
import Contract from "slotworks/utils/contract";
import soundManager from "slotworks/sound/sound-manager";

export default class MatrixForegroundComponent {
    public anounceSpin(spin: number): Contract<number> {
        return new Contract((resolve)=> {
            // let multiplier = Layers.Banners.container.getChildByName('anouncer_multiplier') as extras.BitmapText,
            // spinText = Layers.MatrixForeground.container.getChildByName('spin') as Text,
            // fireworks = Layers.MatrixForeground.container.getChildByName('fireworks_green') as extras.AnimatedSprite;
            // multiplier.visible = true;
            // multiplier.anchor = 0.5;
            // multiplier.scale.set(0);
            // multiplier.text = 'x' + BannerComponent.multiplierValues[spin - 1];
    
            // let multiplierStartPos = new Point(multiplier.x, multiplier.y);
            // let endPosition = new Point(spinText.x,spinText.y);
            // spinText.anchor.set(0.5);
            // spinText.y +=120;
            // spinText.visible = true;
            // spinText.scale.set(0);
            // spinText.text = translations.get('freespins_spin', {"spin": spin});

            // fireworks.visible = true;
            // fireworks.onComplete = () => {
            //     fireworks.visible = false;
            // }
            // fireworks.gotoAndPlay(0);
    
            // new Tween(spinText.scale)
            // .to({x: 0.9, y: 0.9},320)
            // .start();
            // new Tween(spinText)
            // .to({y: endPosition.y},320)
            // .start();
            
            // soundManager.customEvent("freespins_announcement");

            // new Tween(multiplier.scale)
            // .to({x: 0.9, y: 0.9},300)
            // .onComplete(()=>{
            //     new Tween(spinText.scale)
            //     .to({x: 1, y: 1},950)
            //     .onComplete(()=>{
            //         new Tween(spinText.scale)
            //         .to({x: 0, y: 0},200)
            //         .start();
            //     })
            //     .start();
    
            //     new Tween(multiplier.scale)
            //     .to({x: 1, y: 1},900)
            //     .onComplete(()=>{
            //         let bannerMultiplier = (Components.banner as MultiplierBannerComponent).multipliers[spin - 1];
            //         let pos = new Point(
            //             bannerMultiplier.getGlobalPosition().x - (multiplier.getGlobalPosition().x - multiplier.x),
            //             bannerMultiplier.getGlobalPosition().y - (multiplier.getGlobalPosition().y - multiplier.y)
            //         );

            //         new Tween(multiplier)
            //         .to({width: bannerMultiplier.width, height: bannerMultiplier.height},300)
            //         .easing(Easing.Quartic.In)
            //         .start();
    
            //         new Tween(multiplier)
            //         .to({x: [multiplier.x, multiplier.x, pos.x ],y: [multiplier.y, spinText.y, pos.y]},300)
            //         .interpolation(Interpolation.Bezier)
            //         .onComplete(()=>{
            //             multiplier.visible = false;
            //             multiplier.position = multiplierStartPos;
            //             resolve(null);
            //         })
            //         .start();
            //     }) 
            //     .start();            
            // })
            // .start();
            
        })
    }
}